"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowDown = void 0;
/* eslint-disable import/prefer-default-export */
var react_1 = __importDefault(require("react"));
var ArrowDown = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4419 13.0581C18.686 13.3021 18.686 13.6979 18.4419 13.9419L12.4419 19.9419C12.1979 20.186 11.8021 20.186 11.5581 19.9419L5.55806 13.9419C5.31398 13.6979 5.31398 13.3021 5.55806 13.0581C5.80214 12.814 6.19786 12.814 6.44194 13.0581L11.375 17.9911V5.5C11.375 5.15482 11.6548 4.875 12 4.875C12.3452 4.875 12.625 5.15482 12.625 5.5V17.9911L17.5581 13.0581C17.8021 12.814 18.1979 12.814 18.4419 13.0581Z", fill: color })));
};
exports.ArrowDown = ArrowDown;
